module.exports = "https://s91588.cdn.ngenix.net/cs-frontend-v2/_next/static/images/card2-f992fa39470a74c232bae62098804af2.png";